import { t } from '@lingui/core/macro';

import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

import DashboardContent from './DashboardContent';

const Dashboard = () => {
  return (
    <Page title={t`Dashboard`} className="flex flex-col gap-6" exampleAIQuestions={[]}>
      <PageFilterProvider>
        <div className="flex justify-between">
          <PageDateRangeFilter />
          <div className="flex items-center gap-2">
            <PendoPlaceholder />
            <ShareMenu notificationPageKey="dashboard" />
          </div>
        </div>
        <DashboardContent />
      </PageFilterProvider>
    </Page>
  );
};

export default Dashboard;
